import { ResizeBackgroundImportState } from "./types";

export const initialState: ResizeBackgroundImportState = {
    isImporting: false,
    importComplete: false,
    fileSize: 0,
};
